<div *ngIf="payment.PaymentID <= 0 || !payment.DeletePayment" [ngClass]="isAltRow ? 'alt-row p-10' : 'p-10'">
  <div class="mct-flex mct-row mct-gap-80"  >
    <div class="mct-flex mct-col" >
      <div class="field-column">
        <div>
          <label>{{ 'invoices.invoice-builder.payment-tab.payment-type' | translate | titlecase }}</label>
          <p-select
            optionLabel="PaymentType"
            dataKey="PaymentTypeId"
            placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
            [options]="paymentTypes"
            [style]="{ width: '100%' }"
            [(ngModel)]="selectedPaymentType"
            (onChange)="paymentTypeChanged($event)"
            [disabled]="payment.Posted"
          >
          </p-select>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.amount' | translate | titlecase }}</label>
          <div class="p-inputgroup">
            <p-inputNumber
              name="paymentAmount"
              [(ngModel)]="payment.Amount"
              showClear="true"
              [disabled]="payment.Posted"
              mode="currency"
              currency="USD"
              locale="en-US"
              (onInput)="revenueObservationService.invoiceAmountChanged(payment.InvoiceNumber)"
            ></p-inputNumber>
          </div>
        </div>
        <div>
          <label>{{ 'invoices.invoice-builder.payment-tab.payment-source' | translate | titlecase }}</label>
          <p-select
            dataKey="PaymentSource"
            optionLabel="PaymentSource"
            placeholder="{{ 'invoices.invoice-builder.none-label' | translate }}"
            [style]="{ width: '100%' }"
            [(ngModel)]="selectedPaymentSource"
            [options]="paymentSources"
            (onChange)="paymentSourceChanged($event)"
          ></p-select>
        </div>
        <div class="mct-flex mct-row mct-gap-7"  >
          <div class="mct-flex mct-col" >
            <label>{{ 'invoices.invoice-builder.payment-tab.payment-date' | translate | titlecase }}</label>
            <wl-date-selector ngDefaultControl name="paymentDate" [(ngModel)]="payment.PaymentDate"></wl-date-selector>
          </div>
          <div class="mct-flex mct-col" >
            <label>{{ 'invoices.invoice-builder.payment-tab.apply-date' | translate | titlecase }}</label>
            <wl-date-selector ngDefaultControl name="posted" [(ngModel)]="payment.ApplyDate" [disabled]="payment.Posted"></wl-date-selector>
          </div>
        </div>
      </div>
    </div>
    <div class="field-column">
      <div class="mct-flex mct-row mct-justify-between mct-items-center mct-gap-7"   >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.batch-number' | translate | titlecase }}</label>
          <span style="height: 33px">
            <strong>{{ payment.Batch_Creation ? payment.Batch_Creation : '&nbsp;' }}</strong>
          </span>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.payment-id' | translate }}</label>
          <input [disabled]="true" [ngModel]="payment.PaymentID" />
        </div>
      </div>
      <div class="mct-flex mct-row mct-gap-7"  >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.check-number' | translate | titlecase }}</label>
          <input type="text" [(ngModel)]="payment.CheckNum" />
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.payment-header-id' | translate }}</label>
          <input [disabled]="true" [ngModel]="payment.PaymentHeaderID" />
        </div>
      </div>
      <div class="mct-flex mct-row" >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.reference-number' | translate | titlecase }}</label>
          <input type="text" [(ngModel)]="payment.Refno" />
        </div>
        <div></div>
      </div>
      <div class="mct-flex mct-row mct-gap-7"  >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.debit-account' | translate | titlecase }}</label>
          <input type="text" [ngModel]="debitAccount" [disabled]="true" />
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.credit-account' | translate | titlecase }}</label>
          <input type="text" [ngModel]="creditAccount" [disabled]="true" />
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="payment-row-container mv-10 payment-labels">
    <span>{{ 'invoices.invoice-builder.payment-tab.payment-amount-applied' | translate | titlecase }}</span>
    <span class="adjusted-amount-due-cell">{{ 'invoices.invoice-builder.payment-tab.adjusted-amount-due' | translate | titlecase }}</span>
    <span>{{ 'invoices.invoice-builder.payment-tab.revenue-item' | translate | titlecase }}</span>
    <span>{{ 'invoices.invoice-builder.payment-tab.payment-type' | translate | titlecase }}</span>
  </div>
  <div class="payment-row-container mv-10">
    <span type="number">{{ payment.Amount | currency : 'USD' : 'symbol' }}</span>
    <span class="adjusted-amount-due-cell">{{ lineItem.AdjustedAmountDue | currency : 'USD' : 'symbol' }}</span>
    <span> {{ lineItem.Item }} </span>
    <span *ngIf="selectedPaymentType">{{ selectedPaymentType.PaymentType }}</span>
  </div>
  <div   class="mt-10 mct-flex mct-row mct-justify-end mct-items-center">
    <span *ngIf="payment.Posted" class="card-field-label"
      >{{ 'invoices.invoice-builder.payment-tab.payment-posted' | translate | titlecase }}&nbsp;{{
        payment.DatePosted | date : 'MM/dd/yyyy'
      }}</span
    >&nbsp;
    <button pButton type="button" class="btn btn-danger" type="button" (click)="removeSafe()" [disabled]="payment.Posted">
      <i class="pi pi-times"></i>
      {{ 'invoices.invoice-builder.payment-tab.remove-payment' | translate | uppercase }}
    </button>
  </div>
</div>
<p-confirmDialog
  
  icon="pi pi-exclamation-triangle"
  appendTo="body"
>
  <ng-template pTemplate="header">
    {{ 'invoices.invoice-builder.payment-tab.adjustment-warning' | translate | titlecase }}
  </ng-template>
</p-confirmDialog>
